"use client";

import { useMemo } from "react";
import { useSelector } from "react-redux";
import ImageDefault from "@/assets/images/image-default.png";
import { getFileUrl } from "@/utils/getFileUrl";

export const useUser = () => {
  const profileState = useSelector((s: any) => s.profile);
  const sessionLike = profileState?.user || null;

  const user = useMemo(() => {
    const userData = sessionLike;

    // Buscar a imagem de perfil nos files
    const currentImageProfile = userData?.files?.find(
      (file: any) => file.type === "photo",
    );

    // Processar a URL da imagem usando getFileUrl
    let photoUrl: string = ImageDefault.src;
    if (currentImageProfile) {
      photoUrl = getFileUrl(currentImageProfile);
    } else if (userData?.photo) {
      // Fallback para o campo photo direto
      photoUrl = getFileUrl({ path: userData.photo });
    } else if (userData?.image) {
      // Fallback para o campo image
      photoUrl = userData.image;
    }

    return {
      id: userData?.id || null,
      name: userData?.name || "Usuário",
      email: userData?.email || "",
      photo: photoUrl,
      isOwner: userData?.is_owner || false,
      roles: userData?.roles || [],
      permissions: userData?.permissions || [],
      establishment: userData?.establishment || null,
      phone: userData?.phone || "",
      cpf: userData?.cpf || "",
      address: userData?.address || "",
    };
  }, [sessionLike]);

  return {
    user,
    isLoading: profileState?.loading ?? false,
    isAuthenticated: !!profileState?.user,
    session: profileState?.user ? { user: profileState.user } : null,
  };
};
